import React from "react";
import { connect } from 'react-redux';
// import moment from 'moment';

import withStyles from "@material-ui/core/styles/withStyles";

import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";

import TrueMoneyReport from './TrueMoneyReport.jsx';
const style = {};

class TrueMoneyLineReportContainer extends React.Component {


  componentDidMount() {
    const { dispatch } = this.props;
    dispatch({ type: 'REPORT_REDUCER_INIT' })
  }


  render() {
    const { merchantSetting } = this.props;
    return (
      <Card>
        <CardBody>
          <TrueMoneyReport initialValues={{ startDate: null, endDate: null }} />
          {/* initialValues={{ startDate: moment().startOf('day'), endDate: moment().set('hour',23).set('minute',59).set('second',59) }}*/}
        </CardBody>
      </Card>
    )
  }
}

function mapStateToProps(state) {
  const { tableReset } = state.member;
  const { merchantSetting, user, superAdmin, permission } = state.authentication;
  return {
    tableReset, merchantSetting, user, superAdmin, permission
  };
}
const connectTrueMoneyLineReportContainer = connect(mapStateToProps)(TrueMoneyLineReportContainer);

export default withStyles(style)(connectTrueMoneyLineReportContainer);